import type {HydraViolation} from '../../@types/hydra/HydraError'

export class CustomError extends Error {
}

export class SilentError extends Error {
}

export class NetworkError extends Error {
  constructor() {
    super('error.network')
  }
}

export class AbortError extends Error {
  constructor() {
    super('error.aborted')
  }
}

export class TimeoutError extends Error {
  constructor() {
    super('error.timeout')
  }
}

export class IncompleteResponseError extends Error {
  constructor() {
    super('error.incomplete-response')
  }
}

export class ApiError extends Error {
  public readonly description: string
  public readonly statusCode: number

  constructor(message: string, statusCode: number, description: string) {
    super(message)
    this.description = description
    this.statusCode = statusCode
  }
}

export const isNotFoundError = (error: Error): error is ApiError => error instanceof ApiError && error.statusCode === 404

export const isUnavailableError = (error: Error): boolean => error instanceof ApiError && [502, 503, 504].includes(error.statusCode)

export const isTransientError = (error: Error): boolean => error instanceof NetworkError
  || error instanceof TimeoutError
  || error instanceof AbortError
  || error instanceof IncompleteResponseError
  || (error instanceof ApiError && error.statusCode >= 500)

export class ViolationsError extends ApiError {
  public readonly violations: HydraViolation[]

  constructor(message: string, statusCode: number, description: string, violations: HydraViolation[]) {
    super(message, statusCode, description)
    this.violations = violations
  }
}
